/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Welcome_Links_TitleInputs */

const en_welcome_links_title = /** @type {(inputs: Welcome_Links_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resources`)
};

const fr_welcome_links_title = /** @type {(inputs: Welcome_Links_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ressources`)
};

const ms_sg2_welcome_links_title = /** @type {(inputs: Welcome_Links_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sumber`)
};

/**
* | output |
* | --- |
* | "Resources" |
*
* @param {Welcome_Links_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const welcome_links_title = /** @type {((inputs?: Welcome_Links_TitleInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Welcome_Links_TitleInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_welcome_links_title(inputs)
	if (locale === "fr") return fr_welcome_links_title(inputs)
	return ms_sg2_welcome_links_title(inputs)
});